<template>
     <div class="content-wrapper" style="min-height: 0px;overflow-y: auto;overflow-x: hidden;height: calc(100% - 71px)">
        <div id="tabpanel" style="overflow-y: auto;overflow-x: hidden">
                <div class="tabpanel">
                    <div class="tabpanel_tab_content">
						<ul class="breadcrumb" style="padding-top: 2px;float: left;background-color: #f5f5f5;">
							<li>当前位置：</li>
							<li v-for="(item,index) in breads" :key="item.name">
								<a href="javascript:"  v-if="index!=breads.length-1">{{item.name}}</a>
								<span v-if="index==breads.length-1">{{item.name}}</span>
							</li>
						</ul>
                    </div>
                    <div class="tabpanel_content main_container" style="overflow-y: auto;overflow-x: hidden;min-height: calc(100% - 40px);padding-left: 13px;padding-right: 13px;padding-top: 2px;">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
export default {
    name:"RightSide",
    components: {
        
    },
    data:function(){
        return {
            
        }
    },
    computed:{
        breads:function(){
            return this.$store.state.breadcrumb;
        }
    },
    mounted:function(){
		
    },
	methods:{
		
	}
}
</script>